import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";

export const exportCustomerLeadFile = async (params = {}) => {
  const config = {
    headers: { "Content-Type": "blob" },
    responseType: "blob",
    params,
  };
  return jwtAxios.get(URL_API.CMS_CUSTOMER_LEADS.EXPORT, config);
};
